import {
  ImpactShopProductType,
  PAYMENT_TYPE,
  PaymentResponse,
  ImpactShopCheckoutProduct,
  UtmParams,
  ImpactShopCheckoutWithRegistrationPayload,
  ImpactShopCheckoutWithRegistrationResponse,
} from "@ecologi/shared";
import { ITokenCache } from "../../../../packages/auth0/src/tokens/token-cache";
import { fetchFromAPI } from "./fetch-from-api";

export const getAllImpactShopProducts = async (
  tokenCache: ITokenCache,
  options?: RequestInit
): Promise<ImpactShopProductType[]> =>
  fetchFromAPI("/impact-shop/products", options, tokenCache).then(
    (r) => r.products
  );

export const getImpactShopProduct = async (
  slug: string,
  tokenCache: ITokenCache,
  options?: RequestInit
): Promise<ImpactShopProductType> =>
  fetchFromAPI(`/impact-shop/products/${slug}`, options, tokenCache).then(
    (r) => r.product
  );

export const createBasketPayment = async (
  products: ImpactShopCheckoutProduct[],
  currency: string,
  paymentType: PAYMENT_TYPE,
  poNumber: string,
  taxCode: string,
  idempotencyKey: string,
  accessToken: string,
  utmParams?: UtmParams
): Promise<PaymentResponse> =>
  fetchFromAPI("/impact-shop/payment", {
    body: JSON.stringify({
      products,
      currency,
      paymentType,
      idempotencyKey,
      poNumber,
      taxCode,
      utmParams,
    }),
    method: "POST",
    passthrough: "api",
    headers: {
      Authorization: `Bearer ${accessToken}`,
    },
  });

export const getMockedImpact = async (
  paymentType: PAYMENT_TYPE,
  idempotencyKey: string,
  accessToken: string
) => {
  const queryParams = new URLSearchParams({
    paymentType,
    idempotencyKey,
  }).toString();

  return fetchFromAPI(`/impact-shop/post-payment?${queryParams}`, {
    method: "GET",
    passthrough: "api",
    headers: {
      Authorization: `Bearer ${accessToken}`,
    },
  });
};

export const checkoutWithRegistration = async (
  payload: ImpactShopCheckoutWithRegistrationPayload
): Promise<ImpactShopCheckoutWithRegistrationResponse> =>
  fetchFromAPI("/impact-shop-checkout", {
    body: JSON.stringify(payload),
    method: "POST",
    passthrough: "edge",
  });
